import React from 'react';
import classnames from 'classnames';

import './dropdown-arrow.less';

const DropdownArrow = ({ open, focused }) => (
	<div className={classnames('bouncy-arrow-icon', { open, focused })}>
		<span className="left-bar" />
		<span className="right-bar" />
	</div>
);

export default DropdownArrow;
